import React, { Component } from "react";

import styles from "./styles.scss";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import {
	Button,
	Card,
	CardContent,
	Grid,
	Select,
	MenuItem,
	CardHeader,
	CircularProgress,
	Modal
} from "@material-ui/core";
import {
	ArrowDropDown,
	ArrowDropUp,
	Close,
	Assessment,
	ViewStream,
	ViewModule,
	MoreVert,
	Settings,
	Refresh,
	ErrorOutline
} from "@material-ui/icons";
import Highcharts from "highcharts";
import ReactHighcharts from "react-highcharts";
import CSSModules from "react-css-modules";
import { Interval, Point, PointDisplay } from "../../services/Live/types";
import { DateTime, shouldUpdate, array, string, number, seriesColor, deepClone } from "../../utils";
import SearchBar from "../../components/SearchBar/SearchBar";
import Tooltip, { TooltipContent } from "../../components/Tooltip/tooltip";
import Graph from "../../components/OutcomeGraph/OutcomeGraph";
import moment from "moment";
import autobind from "../../libs/react-autobind";
import { DateRangePicker } from "../../libs/react-date-range";
import SmartTable from "../../components/SmartTable/SmartTable";
import Menu, { MenuAction } from "../../components/PopupMenu/menu";

import dots from "../../assets/Icons/Group 2.png";
import red from "../../assets/Icons/Group 5.png";
import spinner from "../../assets/Icons/Group 6.png";
import RuleInstanceLastPingStatus from '../../components/RuleInstanceLastPingStatus/RuleInstanceLastPingStatus';
import rules from '../../services/rules';
import { actions as timeactions } from "../../redux/timeRedux";

@CSSModules(styles, { allowMultiple: true })
class Operations extends Component {
	constructor(props) {
		super(props);
		autobind(this);
		this.state = {
			showStack: false,
			calenderOpen: false,
			showTimes: false
		};
		

		this.props.getData();
		this.scrollElem = document.getElementById("content-scroll");

		this.resize = this.resize.bind(this);
		this.setEnabledFilter = this.setEnabledFilter.bind(this);
		this.openWindow = this.openWindow.bind(this);
		this.renderOptions = this.renderOptions.bind(this);
	}
	sameDay(d1, d2) {
		return (
			d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
		);
	}

	componentDidMount() {
		this.props.setOnPage(true);
		window.addEventListener('resize', this.resize);
	}

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["match"]);
	}

	toggleCalendar() {
		this.setState({ calenderOpen: !this.state.calenderOpen });
	}

	toggleRule(ruleInstanceId, enabled) {
		this.props.toggleRule(ruleInstanceId, enabled);
	}
	
	resize() {
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.resize);
		this.props.setOnPage(false);
	}

	colorText(text) {
		if (/PASS/.test(text)) {
			return "#22B547";
		} else if (/CON/.test(text)) {
			return "#f4b042";
		} else if (/FAIL/.test(text)) {
			return "#f00";
		} else if (/ABORT/.test(text)) {
			return "#8B008B";
		}
	}

	changeTime(result) {
		const range = result.selection || result.range1;
      range.endDate = DateTime.endOf("day", range.endDate);
      this.props.changeTime(range);
	}

	parseObject(item, indent = 0) {
		let rtns = "";
		if (Array.isArray(item)) {
			rtns += "\n";
			for (let index = 0; index < item.length; index++) {
				const t = item[index];
				if (t !== "" && t != null) {
					//add space for each indent
					array.fill(indent, x => (rtns += " "));
					//dont add indent if on first level
					rtns += this.parseObject(t, indent === 0 ? 0 : indent + 3) + "\n";
				}
			}
		} else if (item instanceof Date) {
			rtns += DateTime.parse(item, "D/M hh:mm a");
		} else if (typeof item === "object") {
			rtns += "\n";
			const keys = array.sort(Object.keys(item));
			for (let index = 0; index < keys.length; index++) {
				let prop = keys[index];
				if (item.hasOwnProperty(prop)) {
					const element = item[prop];
					if (element !== "" && element != null) {
						prop = string.capitalizeFirstLetter(string.insertSpaces(prop));
						//add space for each indent
						array.fill(indent, x => (rtns += " "));
						rtns += `${prop}: ${this.parseObject(element, indent + prop.length + 2)}\n`;
					}
				}
			}
		} else {
			rtns += item;
		}
		return rtns;
	}

	moreDetails(row) {
		if (row.outcomes.length === 0) {
			this.props.getOutcomes(row.ruleInstanceId);
		} else {
			this.props.showMore({ ruleOutcomes: row.outcomes });
		}
	}

	moreDetailsPoint(row) {
		if (row.pointOutcomes.length === 0) {
			this.props.getPointOutcomes(row.ruleInstanceId);
		} else {
			this.props.showMore({ points: row.pointOutcomes });
		}
	}

	moreDetailsError(row) {
		if (row.errors.length === 0) {
			this.props.getErrors(row.ruleInstanceId);
		} else {
			this.props.showMore({ errors: row.errors });
		}
	}

	copyJson(row) {
        rules.GetRuleInstanceScheduleAndConfigJson(row.ruleInstanceId)
            .then(data => string.copyTextToClipboard(`{"config":${data.configJson},"schedule":${data.scheduleJson}}`))
            .catch(error => console.error(error));		
	}

	setEnabledFilter(fil) {
		this.props.setEnabledFilter(fil);
	}

	openWindow(ruleInstanceId) {
		window.open(
			"/Reports/" + ruleInstanceId + "/" + 
			this.props.time.startDate.getFullYear() + "-" + this.props.time.startDate.getMonth() + "-" + this.props.time.startDate.getDay() + "," + 
			this.props.time.endDate.getFullYear() + "-" + this.props.time.endDate.getMonth() + "-" + this.props.time.endDate.getDay(), 
			"_blank");
	}

	renderOptions(x, i) {
		const menuActions = [
			new MenuAction("Show Rule Outcomes", e => this.moreDetails(x)),
			new MenuAction("Show Point Outcomes", e => this.moreDetailsPoint(x)),
			new MenuAction("Rule Report", e => this.openWindow(x.ruleInstanceId)
				
				/*this.props.navigate("/Reports/" + x.ruleInstanceId, {
					time: this.props.time
				})*/
			),
			new MenuAction(
				"Show Errors",
				e => this.moreDetailsError(x),
				() => x.numErrors > 0
			),
			new MenuAction((x.enabled ? "Disable Rule" : "Enable Rule"), e => this.toggleRule(x.ruleInstanceId, !x.enabled)),
			new MenuAction("Copy Config JSON", e => this.copyJson(x))
		];
		return (
			<tr key={i} styleName="row">
				<td>{`${x.name} (${x.ruleId}/${x.ruleInstanceId})`}</td>
				<td
					style={{
						color: this.colorText(x.lastRunStatusText),
						fontWeight: "bold"
					}}
				>
				<Tooltip delay={50}>
					<div>
						{x.lastRunStatusText}
					</div>
					<TooltipContent>
						<div styleName="rrule-failed-tooltip">
						RULE_ABORT - some sort of error occurred and the rule stopped running;<br />RULE_PAUSE - rule configuration has a pause period prior to the rule executing;<br />RULE_FAIL - rule does not pass config criteria;<br />RULE_PASS - rule is passing config criteria;<br />PRE_CON_FAILED - Rule not running due to pre-conditions not met;
						</div>
					</TooltipContent>
				</Tooltip>
				</td>
				<td styleName="center">
						<Tooltip delay={50}>
							<div>
								{x.isRunning ? "Yes" : "No"}
								{x.isRunning && <RuleInstanceLastPingStatus lastPingTimeUtc={x.lastPingTimeUtc} /> }
							</div>
							<TooltipContent>
								<div styleName="rrule-failed-tooltip">
									Rule is currently in a run state, and passes scheduling criteria.<br />The green/orange heartbeat circle indicates if the rule has updated the database within the last 35 minutes.<br /><br />Green - has a heartbeat;<br />Orange - database not updated within last 10 minutes;
								</div>
							</TooltipContent>
						</Tooltip>
				</td>
				{this.state.showTimes
					? [
							<td styleName="right" key={9}>
								{number.parseNumber(x.totalHours)}
							</td>,
							<td styleName="right" key={1}>
								{number.parseNumber(x.hoursPass)}
							</td>,
							<td styleName="right" key={2}>
								{number.parseNumber(x.hoursFail)}
							</td>
					  ]
					: [
					  ]}
				<td styleName="right">{parseInt(x.percentPass * 100)}%</td>
				<td styleName="right">{parseInt(x.percentFail * 100)}%</td>
				<td styleName="right">{parseInt(x.percentFailOverTime * 100)}%</td>

				<td styleName="center">
					{DateTime.parse(x.lastStartedUtc, "D/M hh:mm a")}
				</td>
				<td styleName="center">
					{DateTime.parse(x.lastOutputDate, "D/M")}
				</td>
				{
					this.props.enabledFilter === null &&
					<td styleName="center">
						{ x.enabled ? "Enabled" : "Disabled" }
					</td>
				}
				<td styleName="waitingon">{x.waitingOn}</td>
				<td styleName="right vcenter">
					{x.numErrors > 0 && <img styleName="reporti" src={red} />}
					<Menu actions={menuActions}>
						<img styleName="dots" src={dots} />
					</Menu>
				</td>
			</tr>
		);
	}

	render() {		
		return (
			<div styleName="outer">
				{/* click area to close calender */}
				{this.props.calenderOpen && <div onClick={this.toggleCalendar} styleName="toggle-area" />}
				<div styleName="header">
					<div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
						<SearchBar
							timeout={500}
							searchBarId={"ops/List"}
							style={{
								backgroundColor: "transparent",
								minHeight: 30,
								height: 60,
								marginLeft: 15,
								marginRight: 15,
								paddingRight: 15,
								borderBottomWidth: 0,
								minWidth: 200
							}}
							inputStyle={{ borderWidth: 0, marginRight: 40 }}
							iconStyle={{ color: "#FFFFFF" }}
							inputWrapClass="_inputWrap"
						/>
						{this.props.searchText &&
							this.props.searchText !== "" && <Button onClick={() => this.props.search()}>Search</Button>}
						{this.props.hasSearched && <Button onClick={() => this.props.clearSearch()}>Clear</Button>}
						{this.props.isSearchBusy && <CircularProgress />}
						{this.props.hasSearched === true && (
							<div styleName="searchResults">{this.props.searchResults} results found.</div>
						)}
					</div>
					<div styleName="header-spacer" />
					{
						this.props.enabledFilter === true ? (
							<Button onClick={() => this.setEnabledFilter(false)}>Enabled Only ({this.props.numOfEnabled})</Button>
						) : (
							this.props.enabledFilter === false ? (
								<Button onClick={() => this.setEnabledFilter(null)}>Disabled Only ({this.props.numOfDisabled})</Button>
							) : (
								<Button onClick={() => this.setEnabledFilter(true)}>Enabled ({this.props.numOfEnabled}) & Disabled ({this.props.numOfDisabled})</Button>
							)
						)
					}
					{this.state.showTimes ? (
						<Button onClick={() => this.setState({ showTimes: false })}>Hours</Button>
					) : (
						<Button onClick={() => this.setState({ showTimes: true })}>Counts</Button>
					)}

					{this.props.isBusy ? (
						<CircularProgress />
					) : (
						<img styleName="refresh" onClick={this.props.getData} src={spinner} />
					)}
					<div styleName="select-group-container">
						<Button onClick={this.toggleCalendar} styleName="date-btn">
							{this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
								`${DateTime.formatToLocaleLongDate(this.props.time.startDate)}`}
							{!this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
								`${DateTime.formatToLocaleLongDate(
									this.props.time.startDate
								)} - ${DateTime.formatToLocaleLongDate(this.props.time.endDate)}`}
							{this.props.calenderOpen && <ArrowDropUp style={{ fill: "rgba(0, 0, 0, 0.54)" }} />}
							{!this.props.calenderOpen && <ArrowDropDown style={{ fill: "rgba(0, 0, 0, 0.54)" }} />}
						</Button>
					</div>
					<div styleName="calendar-wrap" isopen={this.state.calenderOpen.toString()}>
						<div styleName="drpContainer">
							<DateRangePicker
								ranges={[this.props.time]}
								dragSelectionEnabled={false}
								showSelectionPreview={true}
								onChange={this.changeTime}
								showPreview={true}
							/>
							<div styleName="drpCloseButtonContainer">
								<div style={{ flex: 1 }} />
								<div styleName="drpCloseButton" onClick={this.toggleCalendar}>
									Close
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div styleName="content">
					<Card styleName="maincard">
						<CardContent styleName="cardcontent">
							<SmartTable
								smartTableId="ops-table"
								tableClass="tableclass"
								thClass="th"
								tdClass="td"
								sortChevronClass="sort-icon"
								columns={ 19}
								data={this.props.data}
								changeData={newData => this.props.changeData(newData)}
								useResponsiveColumns={true}
								breakOn="sm"
								allowColumnSort={true}
								rowsPerPage={10}
								stickyHeaderScrollRef={this.scrollElem}
								classes={styles}
							>
								<thead>
									<tr>
										<th sortable="name">Name (Rule/ID)</th>
										<th sortable="lastRunStatusText">
											<Tooltip delay={50}>
												<div>
													Status
												</div>
												<TooltipContent>
													<div styleName="rrule-failed-tooltip">
													RULE_ABORT - some sort of error occurred and the rule stopped running;<br />RULE_PAUSE - rule configuration has a pause period prior to the rule executing;<br />RULE_FAIL - rule does not pass config criteria;<br />RULE_PASS - rule is passing config criteria;<br />PRE_CON_FAILED - Rule not running due to pre-conditions not met;
													</div>
												</TooltipContent>
											</Tooltip>
										</th>
										<th styleName="center" sortable="isRunning">
											
											<Tooltip delay={50}>
												<div>
													Running Now
												</div>
												<TooltipContent>
													<div styleName="rrule-failed-tooltip">
														Rule is currently in a run state, and passes scheduling criteria.<br />The green/orange heartbeat circle indicates if the rule has updated the database within the last 10 minutes.<br /><br />Green - has a heartbeat;<br />Orange - database not updated within last 10 minutes;
													</div>
												</TooltipContent>
											</Tooltip>
										</th>

										<th styleName="right" hide={!this.state.showTimes ? "true": undefined}sortable="totalHours">
											Total Hours
													</th>
										<th styleName="right" hide={!this.state.showTimes ? "true": undefined}sortable="hoursPass">
											Hours Pass
													</th>
										<th styleName="right" hide={!this.state.showTimes ? "true": undefined}sortable="hoursFail">
											Hours Fail
													</th>

										<th styleName="right" sortable="percentPass">
											<Tooltip delay={50}>
												<div>
													% Pass
												</div>
												<TooltipContent>
													<div styleName="rrule-failed-tooltip">
														A running rule passing configured criteria
													</div>
												</TooltipContent>
											</Tooltip>
										</th>
										<th styleName="right" sortable="percentFail">
											<Tooltip delay={50}>
												<div>
													% Fail/Run Time
												</div>
												<TooltipContent>
													<div styleName="rrule-failed-tooltip">
														Rule does not pass criteria based on the rule configuration
													</div>
												</TooltipContent>
											</Tooltip>
										</th>
										<th styleName="right" sortable="percentFailOverTime">
											<Tooltip delay={50}>
												<div>
													% Fail/Time Period
												</div>
												<TooltipContent>
													<div styleName="rrule-failed-tooltip">
														Rule does not pass criteria based on the rule configuration
													</div>
												</TooltipContent>
											</Tooltip>
										</th>

										<th styleName="center" sortable="lastStartedUtc">
											<Tooltip delay={50}>
												<div>
													Last Started
												</div>
												<TooltipContent>
													<div styleName="rrule-failed-tooltip">
														When this rule last started
													</div>
												</TooltipContent>
											</Tooltip>
										</th>
										<th styleName="center" sortable="lastOutputDate">
											<Tooltip delay={50}>
												<div>
													Last Output Date
												</div>
												<TooltipContent>
													<div styleName="rrule-failed-tooltip">
														The last time point in time the rule has processed and written to the database.
													</div>
												</TooltipContent>
											</Tooltip>
										</th>
										{
											this.props.enabledFilter === null &&
											<th styleName="center">
												Enabled
											</th>
										}
										<th styleName="center" >
											<Tooltip delay={50}>
												<div>
													Waiting On
												</div>
												<TooltipContent>
													<div styleName="rrule-failed-tooltip">
														Indicates what the rule is currently waiting for. That could be a precondition, or for historical rules it could be data.
													</div>
												</TooltipContent>
											</Tooltip>
										</th>
										<th>
											<div />
										</th>
									</tr>
								</thead>
								<tbody>
									{this.props.data.map((x, i) => this.renderOptions(x, i))}
								</tbody>
							</SmartTable>
						</CardContent>
					</Card>
					<Modal
						open={this.props.moreDetails && !!this.props.moreDetails.ruleOutcomes}
						style={{ display: "flex", justifyContent: "center" }}
						onClose={() => {
							this.props.showMore(null);
						}}
					>
						<div className="modal-wrap">
							<div className="modal-header">
								Rule Outcomes <Close onClick={() => this.props.showMore(null)} styleName="pointer" />
							</div>
							<div styleName="modalContent">
								{this.props.moreDetails &&
									this.props.moreDetails.ruleOutcomes && (
										<SmartTable
											smartTableId="ops-table-moredetails"
											tableClass="tableclass"
											thClass="th"
											sortChevronClass="sort-icon"
											tdClass="td aligntop"
											columns={6}
											data={this.props.moreDetails.ruleOutcomes}
											changeData={newData => {
												this.props.moreDetails.ruleOutcomes = newData;
												this.props.showMore({ ...this.props.moreDetails });
											}}
											useResponsiveColumns={true}
											breakOn="sm"
											allowColumnSort={true}
											rowsPerPage={0}
											classes={styles}
										>
											<thead>
												<tr>
													<th sortable="runStateText">Status</th>
													<th
														styleName="center"
														sortable="startSiteLocal"
														default-sort="desc"
													>
														Start Time
													</th>
													<th styleName="center" sortable="endSiteLocal">
														End Time
													</th>
													<th styleName="right" sortable="count">
														Count
													</th>
													<th styleName="center">Snapshot</th>
													<th styleName="center">Stats</th>
												</tr>
											</thead>
											<tbody>
												{this.props.moreDetails.ruleOutcomes.length === 0 && (
													<tr>
														<td styleName="center" colSpan={6}>
															No Data Available
														</td>
													</tr>
												)}
												{this.props.moreDetails.ruleOutcomes.map((x, i) => {
													return (
														<tr key={i}>
															<td
																style={{
																	color: this.colorText(x.runStateText),
																	fontWeight: "bold"
																}}
															>
																{x.runStateText}
															</td>
															<td styleName="center">
																{DateTime.parse(x.startSiteLocal, "D/M hh:mm a")}
															</td>
															<td styleName="center">
																{DateTime.parse(x.endSiteLocal, "D/M hh:mm a")}
															</td>
															<td styleName="right">{x.count}</td>
															<td>
																<pre>
																	{this.parseObject(x.pointSnapshot).replace(
																		/^\s*|\s*$/g,
																		""
																	)}
																</pre>
															</td>
															<td>
																<pre>
																	{this.parseObject(x.stats).replace(
																		/^\s*|\s*$/g,
																		""
																	)}
																</pre>
															</td>
														</tr>
													);
												})}
											</tbody>
										</SmartTable>
									)}
							</div>
						</div>
					</Modal>
					<Modal
						open={this.props.moreDetails && !!this.props.moreDetails.points}
						style={{ display: "flex", justifyContent: "center" }}
						onClose={() => {
							this.props.showMore(null);
						}}
					>
						<div className="modal-wrap">
							<div className="modal-header">
								Rule Point Outcomes <Close onClick={() => this.props.showMore(null)}  styleName="pointer"/>
							</div>
							<div styleName="modalContent">
								{this.props.moreDetails &&
									this.props.moreDetails.points && (
										<SmartTable
											smartTableId="ops-table-moredetails-points"
											tableClass="tableclass"
											thClass="th"
											sortChevronClass="sort-icon"
											tdClass="td aligntop"
											columns={9}
											data={this.props.moreDetails.points}
											changeData={newData => {
												this.props.moreDetails.points = newData;
												this.props.showMore({ ...this.props.moreDetails });
											}}
											useResponsiveColumns={true}
											breakOn="sm"
											allowColumnSort={true}
											rowsPerPage={0}
											classes={styles}
										>
											<thead>
												<tr>
													<th sortable="point">Point</th>
													<th sortable="pointId" styleName="right">
														Point ID
													</th>
													<th sortable="runStateText">Status</th>
													<th
														styleName="center"
														sortable="startSiteLocal"
														default-sort="desc"
													>
														Start Time
													</th>
													<th styleName="center" sortable="endSiteLocal">
														End Time
													</th>
													<th styleName="right" sortable="count">
														Count
													</th>
													<th sortable="upperRange" styleName="right">
														Upper Limit?
													</th>
													<th sortable="lowerRange" styleName="right">
														Lower Limit?
													</th>
													<th styleName="center">Stats</th>
												</tr>
											</thead>
											<tbody>
												{this.props.moreDetails.points.length === 0 && (
													<tr>
														<td styleName="center" colSpan={9}>
															No Data Available
														</td>
													</tr>
												)}
												{this.props.moreDetails.points.map((x, i) => {
													return (
														<tr key={i}>
															<td>{x.point}</td>
															<td styleName="right">{x.pointId}</td>
															<td
																style={{
																	color: this.colorText(x.runStateText),
																	fontWeight: "bold"
																}}
															>
																{x.runStateText}
															</td>
															<td styleName="center">
																{DateTime.parse(x.startSiteLocal, "D/M hh:mm a")}
															</td>
															<td styleName="center">
																{DateTime.parse(x.endSiteLocal, "D/M hh:mm a")}
															</td>
															<td styleName="right">{x.count}</td>
															<td styleName="right">{x.upperRange}</td>
															<td styleName="right">{x.lowerRange}</td>
															<td>
																<pre>
																	{this.parseObject(x.args).replace(/^\s*|\s*$/g, "")}
																</pre>
															</td>
														</tr>
													);
												})}
											</tbody>
										</SmartTable>
									)}
							</div>
						</div>
					</Modal>
					<Modal
						open={this.props.moreDetails && !!this.props.moreDetails.errors}
						style={{ display: "flex", justifyContent: "center" }}
						onClose={() => {
							this.props.showMore(null);
						}}
					>
						<div className="modal-wrap">
							<div className="modal-header">
								Rule Errors <Close onClick={() => this.props.showMore(null)} styleName="pointer" />
							</div>
							<div styleName="modalContent">
								{this.props.moreDetails &&
									this.props.moreDetails.errors && (
										<SmartTable
											smartTableId="ops-table-moredetails-errors"
											tableClass="tableclass"
											thClass="th"
											sortChevronClass="sort-icon"
											tdClass="td aligntop"
											columns={4}
											data={this.props.moreDetails.errors}
											changeData={newData => {
												this.props.moreDetails.errors = newData;
												this.props.showMore({ ...this.props.moreDetails });
											}}
											useResponsiveColumns={true}
											breakOn="sm"
											allowColumnSort={true}
											rowsPerPage={0}
											classes={styles}
										>
											<thead>
												<tr>
													<th styleName="center" sortable="createdOnUtc">
														Created On
													</th>
													<th sortable="description">Description</th>
													<th sortable="description2">Description 2</th>
													<th sortable="stack">Stack</th>
												</tr>
											</thead>
											<tbody>
												{this.props.moreDetails.errors.length === 0 && (
													<tr>
														<td styleName="center" colSpan={4}>
															No Data Available
														</td>
													</tr>
												)}
												{this.props.moreDetails.errors.map((x, i) => {
													return (
														<tr key={i}>
															<td styleName="center">
																{DateTime.parse(x.createdOnUtc, "D/M hh:mm:ss a")}
															</td>
															<td>
																<pre>{x.description}</pre>
															</td>
															<td>
																<pre>{x.description2}</pre>
															</td>
															<td>
																<pre>{x.stack}</pre>
															</td>
														</tr>
													);
												})}
											</tbody>
										</SmartTable>
									)}
							</div>
						</div>
					</Modal>
				</div>
			</div>
		);
	}
}

const bindAction = dispatch => {
	return {
		changeData: data => dispatch(actions.onGetData(data)),
		changeTime: time => dispatch(timeactions.updateTimeRange(time)),
		getOutcomes: rule => dispatch(actions.getOutcomes(rule)),
		getPointOutcomes: rule => dispatch(actions.getPointOutcomes(rule)),
		getErrors: rule => dispatch(actions.getErrors(rule)),
		showMore: rule => dispatch(actions.showMore(rule)),
		getData: () => dispatch(actions.getData()),
		toggleRule: (ri, en) => dispatch(actions.toggleRule(ri, en)),

		setEnabledFilter: (fil) => dispatch(actions.setEnabledFilter(fil)),
		setOnPage: (v) => dispatch(actions.setOnPage(v)),

		navigate: (uri, data) => dispatch(router.push(uri, data)),
		goBack: () => dispatch(router.goBack())
	};
};

const mapStateToProps = state => ({
	data: state.operations.data,
	time: state.time.timeRange,
	moreDetails: state.operations.moreDetails,
	numRun: state.operations.numRun,
	numErrors: state.operations.numErrors,
	enabledFilter: state.operations.enabledFilter,
	failData: state.operations.failData,

	numOfEnabled: state.operations.numOfEnabled,
	numOfDisabled: state.operations.numOfDisabled,

	isBusy: state.operations.isBusy,
	errors: state.operations.errors,
	onPage: state.operations.onPage,
});

export default connect(
	mapStateToProps,
	bindAction
)(Operations);


// WEBPACK FOOTER //
// ./src/ui/Operations/Operations.js